import { z } from 'zod';

const jsonString = z.string().transform((val, ctx) => {
  try {
    return JSON.parse(val);
  } catch {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid JSON string',
    });
    return z.NEVER;
  }
});

export function jsonEncoded<T extends z.ZodTypeAny>(schema: T) {
  return jsonString.pipe(schema);
}
